module.exports = __webpack_public_path__ + "img/central-alabama-logo.d9628406.jpg";